// @ds/actions/RealtimeChannelsContext — minimal realtime channel registry
// context owned by the design system. The app
// (`src/contexts/RealtimeContext.tsx`) keeps the supabase channel multiplexer
// and injects `{ register, unregister }` at the boundary via
// `RealtimeChannelsProvider`.
//
// The context object + `useRealtimeChannels` hook live in the sibling
// `@ds/actions/useRealtimeChannels` module.
import React from "react";
import {
  RealtimeChannelsContext,
  type RealtimeChannelsValue,
} from "@ds/actions/useRealtimeChannels";

export type { RealtimeChannelsValue } from "@ds/actions/useRealtimeChannels";

export const RealtimeChannelsProvider: React.FC<{
  value: RealtimeChannelsValue;
  children: React.ReactNode;
}> = ({ value, children }) => (
  <RealtimeChannelsContext.Provider value={value}>
    {children}
  </RealtimeChannelsContext.Provider>
);
